<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <router-link
            class="btn btn-action btn-action-back"
            :to="`/schedules-monthly`">
            <i class="fas fa-chevron-left" />
          </router-link>
          <div class="title-container">
            <div class="subtitle">แก้ไขผังเดือน</div>
            <div class="title">{{getScheduleName()}}</div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <small class="text-success font-weight-bold mr-3" v-if="saveScheduleState.isSaved">
              <i class="fa fa-check" /> บันทึกแล้ว
            </small>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!isValid"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <SectionScheduleMonthlyInformation
          :schedule.sync="schedule"
          :saveScheduleStateError.sync="saveScheduleState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';
import errorFormatter from '@/utils/errorFormatter';
import Page from '@/layouts/Page.vue';

import { updateScheduleById } from './api';
import SectionScheduleMonthlyInformation from './SectionScheduleMonthlyInformation.vue';

export default {
  mixins: [dateFormetter, errorFormatter],
  props: {
    scheduleData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    SectionScheduleMonthlyInformation,
  },
  data() {
    return {
      schedule: null,
      currentSchedule: null,
      errorStatus: null,
      saveScheduleState: {
        isSaved: false,
        error: { // required field
          name: null,
        },
      },
    };
  },
  created() {
    this.schedule = _.cloneDeep(this.scheduleData);
    this.currentSchedule = _.cloneDeep(this.scheduleData);
  },
  computed: {
    scheduleId() {
      return this.$route.params.scheduleId;
    },
    isScheduleValid() {
      return this.schedule.name;
    },
    haveErrorMessage() {
      return _.some(this.saveScheduleState.error, (value) => value);
    },
    isValid() {
      return this.isScheduleValid && !this.haveErrorMessage;
    },
  },
  methods: {
    async onSubmit() {
      this.saveScheduleState.isSaved = false;
      try {
        const scheduleResponse = await updateScheduleById(this.scheduleId, this.schedule);
        this.schedule = scheduleResponse.data;
        this.currentSchedule = _.cloneDeep(scheduleResponse.data);
        this.saveScheduleState.isSaved = true;
        this.errorStatus = null;
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveScheduleState.error = this.transformErrorData(error.response.data);
      }
    },
    isServerError() {
      return this.errorStatus;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422) {
        return 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
      if (errorStatus === 404) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
    },
    getScheduleName() {
      return _.get(this.currentSchedule, 'name', this.scheduleId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
